import { FunctionComponent } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Paper from '@mui/material/Paper'
import { TextField, Typography } from '@mui/material'
import Button from '@mui/material/Button'
import { useFormik } from 'formik'
import { always, compose } from 'ramda'

import axios from 'src/utilities/http-client'
import validationSchema from './validators/reset-password.validators'

let ResetPassword: FunctionComponent = () => {
  let navigate = useNavigate()
  let [searchParams] = useSearchParams()
  let userId = searchParams.get('userId')
  let token = searchParams.get('token')
  let form = useFormik({
    validationSchema,
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    onSubmit: (values) =>
      axios
        .post('/api/reset-password', {
          password: values.password,
          confirmPassword: values.confirmPassword,
          userId,
          token,
        })
        .then(() =>
          // eslint-disable-next-line no-alert
          window.alert('Your password has been successfully reset'),
        )
        .then(compose(navigate, always('/') as any) as any)
        .catch((err) =>
          // eslint-disable-next-line no-alert
          window.alert(
            err?.response?.data?.error ?? 'Unable to reset password',
          ),
        ),
  })

  return (
    <>
      <Paper className="m-4 p-4 w-1/2 mx-auto">
        <Typography>
          Please enter your new password and confirm it to reset your password.
          Your password must contain at least 1 Capital, 1 Lower-case, 1 number,
          1 special character and be at least 8 digits long.
        </Typography>
        <form onSubmit={form.handleSubmit}>
          <TextField
            variant="standard"
            className="mx-2"
            label="New Password"
            name="password"
            type="password"
            onChange={form.handleChange}
            error={form.touched.password && !!form.errors.password}
            helperText={form.touched.password && form.errors.password}
          />

          <TextField
            variant="standard"
            className="mx-2"
            label="Confirm New Password"
            name="confirmPassword"
            type="password"
            onChange={form.handleChange}
            error={
              form.touched.confirmPassword && !!form.errors.confirmPassword
            }
            helperText={
              form.touched.confirmPassword && form.errors.confirmPassword
            }
          />

          <div className="flex justify-end">
            <Button
              variant="outlined"
              className="mt-4 mr-3"
              onClick={compose(navigate, always('/') as any) as any}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              className="mt-4 mr-3"
            >
              Submit
            </Button>
          </div>
        </form>
      </Paper>
    </>
  )
}

export default ResetPassword
